<div class="input-wrapper">
  <mat-checkbox [checked]="textIsEditable" (change)="textIsEditable = !textIsEditable"> Text editable </mat-checkbox>
  <br />
  <mat-checkbox [checked]="addPossible" (change)="addPossible = !addPossible"> Add rows possible </mat-checkbox>
  <br />
  <mat-checkbox [checked]="removePossible" (change)="removePossible = !removePossible"> Rows removable </mat-checkbox>

  <form #form="ngForm">
    <mad-quick-list
      addLabel="Add Item"
      [allItems]="items"
      [addPossible]="addPossible && form.valid"
      [removePossible]="removePossible"
      [readonly]="!textIsEditable"
      (added)="onItemAdded($event)"
      (removed)="onItemRemoved($event)"
    >
      <label>Enter some names</label>
      <ng-template let-item>
        <!-- Custom content below -->
        <span class="fx fx-row">
          <mad-readonly-form-field-wrapper [value]="item.firstName" [readonly]="!textIsEditable">
            <mat-form-field class="form-group">
              <mat-label>First Name</mat-label>
              <input [(ngModel)]="item.firstName" [name]="'firstName-' + item.id" autocomplete="off" class="form-control" matInput />
            </mat-form-field>
          </mad-readonly-form-field-wrapper>

          <mad-readonly-form-field-wrapper [value]="item.lastName" [readonly]="!textIsEditable">
            <mat-form-field class="form-group">
              <mat-label>Last Name</mat-label>
              <input [(ngModel)]="item.lastName" [name]="'lastName-' + item.id" autocomplete="off" class="form-control" matInput />
              <mat-error> Please enter a last name </mat-error>
            </mat-form-field>
          </mad-readonly-form-field-wrapper>
        </span>
      </ng-template>
    </mad-quick-list>
  </form>
</div>

<div>
  <mad-primary-button>Save</mad-primary-button>
  <mad-outline-button>Cancel</mad-outline-button>
</div>
